





















import { Component, Watch, Vue } from 'vue-property-decorator'
import * as config from '@/config'
import PageObj from '@/models/Page'
import TeamMember from '@/models/TeamMember'

import Content from '@/components/Content.vue'
import Team from '@/components/Team.vue'
import Artists from '@/components/Artists.vue'
import Management from '@/components/Management.vue'
import Events from '@/components/Events.vue'

@Component({
  components: {
    Content,
    Team,
    Artists,
    Management,
    Events,
  },
  metaInfo() {
    return {
      title: (this as any).metaTitle,
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: (this as any).metaDescription || config.meta.description,
        },
      ],
    }
  },
})
export default class Page extends Vue {
  // data
  response: PageObj|{} = {}
  isBasicPage: boolean = false
  hasTeam: boolean = false
  metaTitle: string = ''
  metaDescription: string = ''

  // methods
  getPageContent() {
    const url = `${config.api.baseURL}${config.api.pagesURL}${this.$route.path}`
    const fetchAsync = async () => (await fetch(url, config.api.fetchOptions)).json()

    fetchAsync()
      .then((data: PageObj) => {
        this.response = data
        this.isBasicPage = data.templateName === 'basic-page'
        this.hasTeam = 'team' in data.pageData && data.pageData.team!.length > 0
        this.metaTitle = data.title
        this.metaDescription = data.description
      })
  }

  @Watch('$route.path')
  onPropertyChanged() {
    this.getPageContent()
  }

  // livecycle
  created() {
    this.getPageContent()
  }
}
